import { httpService, WebRequestFactory, withCamelResponse, fromStatusCodeToGenericError } from "@pjs/http";
import { apiConfig } from "../../../../ApiConfig";
import { AuthorisedDeviceResponse } from "../types/AuthorisedDeviceResponse";
import { authorisedDevicesMapper } from "../mappers/AuthorisedDevicesMapper.function";
import { IAuthorisedDeviceWithState } from "../interfaces/IAuthorisedDeviceWithState";

export const getAuthorisedDevices = WebRequestFactory.createGet<Array<IAuthorisedDeviceWithState>>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: withCamelResponse<AuthorisedDeviceResponse, Array<IAuthorisedDeviceWithState>>(authorisedDevicesMapper),
    url: () => apiConfig.getAuthorisedDevices()
});
